<div title="{{tooltip}}" style="display: inline-flex; width: 100%">
  <field-checkbox name="{{id}}"  {enabled}="active" {border}="border"></field-checkbox>
</div>
